
import { Component, Inject, ChangeDetectionStrategy } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { OuiBanner, OuiBannerAction } from 'omnium-ui/banner';
import { OuiButtonModule } from 'omnium-ui/button';
import { OuiDialogModule } from 'omnium-ui/dialog';
import { OuiIconModule } from 'omnium-ui/icon';
import { OuiLoadingModule } from 'omnium-ui/loading';
import { OuiSnackbarModule, OuiSnackbarService } from 'omnium-ui/snackbar';
import { DraftOperationsService } from 'src/service/draft-operation/draft-operation.service';

@Component({
    selector: 'app-declare-operation-dialog',
    imports: [
    OuiDialogModule,
    OuiButtonModule,
    OuiIconModule,
    OuiBanner,
    OuiSnackbarModule,
    OuiLoadingModule
],
    templateUrl: './declare-operation-dialog.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrls: ['./declare-operation-dialog.component.scss']
})
export class DeclareOperationDialogComponent {
  isLoading: boolean = false;
  isSouscription: boolean = false;
  message: string = '';
  hasOutdatedDocumentsWarning: boolean = false;
  bannerSeeOutdatedDocumentsAction: OuiBannerAction = {
    label: 'Voir',
    action: () => {
      this.closeAndViewDocuments();
    },
  };

  constructor(
    private draftOperationService: DraftOperationsService,
    private snackbarService: OuiSnackbarService,
    private dialogRef: MatDialogRef<DeclareOperationDialogComponent>,
    @Inject(MAT_DIALOG_DATA)
    private data: {
      isSouscription: boolean;
    }
  ) {}

  ngOnInit(): void {
    this.isSouscription = this.data.isSouscription ?? false;

    this.message =
      "<p>Pensez à bien ajouter <b> tous les documents de l'opération (bulletins, justificatifs)</b>." +
      " La liste des documents exigés n'est pas nécessairement exhaustive.</p>";
    this.loadOutdatedDocumentsWarning();
  }

  async declareOperation() {
    this.isLoading = true;
    try {
      if (!this.hasOutdatedDocumentsWarning) {
        const outdatedDocuments = await this.draftOperationService.getOutdatedOperationDocuments();
        if (outdatedDocuments.length > 0) {
          this.hasOutdatedDocumentsWarning = true;
          this.isLoading = false;
          return;
        }
      }

      var result = await this.draftOperationService.declareAllOperationsInGroup(this.hasOutdatedDocumentsWarning);
      if (result) {
        this.snackbarService.open(
          'Votre opération a bien été déclarée. Vous pouvez la retrouver dans l\'onglet "En cours de traitement"',
          'success',
          7000,
          { horizontal: 'left', vertical: 'bottom' }
        );
        this.dialogRef.close(true);
      }
    } catch (error) {
      this.snackbarService.open("Une erreur est survenue durant la déclaration de l'opération", 'error', 5000);
    }

    this.isLoading = false;
  }

  closeAndViewDocuments() {
    this.dialogRef.close('viewOutdatedDocuments');
  }

  private async loadOutdatedDocumentsWarning() {
    const outdatedDocuments = await this.draftOperationService.getOutdatedOperationDocuments();
    this.hasOutdatedDocumentsWarning = outdatedDocuments.length > 0;
  }
}
